exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/*\n *\n * Main stylesheet for Switchery.\n * http://abpetkov.github.io/switchery/\n *\n */\n\n.switchery {\n    background-color: #fff;\n    border: 1px solid #dfdfdf;\n    border-radius: 20px;\n    cursor: pointer;\n    display: inline-block;\n    height: 30px;\n    position: relative;\n    vertical-align: middle;\n    width: 50px;\n\n    -webkit-box-sizing: content-box;\n    -moz-box-sizing: content-box;\n    box-sizing: content-box;\n}\n\n.switchery > small {\n    background: #fff;\n    border-radius: 100%;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);\n    height: 30px;\n    position: absolute;\n    top: 0;\n    width: 30px;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./packages/custom/bids/public/assets/css/switchery.css
// module id = 648
// module chunks = 0